import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconText1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconText1"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3.5C3 3.22386 3.22386 3 3.5 3H20.5C20.7761 3 21 3.22386 21 3.5V5.5C21 5.77614 20.7761 6 20.5 6C20.2239 6 20 5.77614 20 5.5V4H12.5V20H14.5C14.7761 20 15 20.2239 15 20.5C15 20.7761 14.7761 21 14.5 21H9.5C9.22386 21 9 20.7761 9 20.5C9 20.2239 9.22386 20 9.5 20H11.5V4H4V5.5C4 5.77614 3.77614 6 3.5 6C3.22386 6 3 5.77614 3 5.5V3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconText1;
